import React from 'react';
import Faculty from '../../Faculty';
import Html from '../Html';
import AccordionList from '../../Accordion/List';
import Graduates from '../../Graduates';
import ImageSlice from '../../ImageSlice';
import ImageSliceGrid from '../../ImageSlice/Grid';

const slices = {
  PrismicPageBodyContent: {
    component: Html,
    resolver: ({ primary }) => {
      const html = primary.rich_text_content.html;
      return {
        dangerouslySetInnerHTML: {
          __html: html,
        },
      };
    },
  },
  PrismicPageBodyFaculty: {
    component: Faculty,
    resolver: ({ primary, items }) => {
      return {
        title: primary?.faculty_section_title?.text,
        members: items.map(item => {
          const payload = item?.faculty_member?.document.data;
          const { name, portrait, position, bio } = payload;
          const imageFluid = portrait?.fluid;
          return {
            name,
            imageFluid,
            position,
            bio: bio.html,
          };
        }),
      };
    },
  },
  PrismicPageBodyFaqSection: {
    component: AccordionList,
    resolver: ({ primary, items }) => {
      return {
        heading: primary.faq_title_description.html,
        items: items.map(item => ({
          title: item.faq_question,
          content: item.faq_answer.html,
        })),
      };
    },
  },
  PrismicPageBodyListOfGraduatesPractitioners: {
    component: Graduates,
    resolver: data => data,
  },
  PrismicPageBodyImage: {
    component: ImageSlice,
    resolver: data => data.primary,
  },
  PrismicPageBodyImageGrid: {
    component: ImageSliceGrid,
    resolver: data => ({ items: data.items }),
  },
};

const PrismicSlice = ({ data }) => {
  const type = data.__typename;
  const slice = slices[type];
  if (slice) {
    const props = slice.resolver(data);
    const Component = slice.component;
    return <Component {...props} />;
  }
  return null;
};

export default PrismicSlice;
